const PublicLayout = ({ children }) => {
    return children;
};

export default PublicLayout;
